import React, { useContext, useEffect, useState } from 'react';
import { TaskContext } from '../Payoff';
import ModalFinishTask from './ModalFinishTask';
import CardLender from './CardLender';
import { Task, TaskResponse } from '../../../../gql/graphql';
import { useGetTaskResponsesByTask } from '../../../../services/task/querys';
import SectionIssues from '../../../SectionIssues/SectionIssues';
import CardUploadResponse from '../../components/Atoms/Cards/CardUploadResponse/CardUploadResponse';
import ActionAcceptAndReject from '../../../ActionAcceptAndReject/ActionAcceptAndReject';
import AddAnotherDoc from '../../components/Organisms/AddAnotherDoc/AddAnotherDoc';
import CardBorrowerImpersonation from '../../../CardBorrowerImpersonation/CardBorrowerImpersonation';

interface Props {
  closeTask: Function;
}

const Step2 = ({ closeTask }: Props) => {
  const task: Task | any = useContext(TaskContext);

  const { data: taskResponses } = useGetTaskResponsesByTask({
    variables: { findResponsesByTask: { taskId: task._id } }
  });

  const [modalFinishTask, setModalFinishTask] = useState<boolean>(false);
  const [responseStep1, setResponseStep1] = useState<TaskResponse | any>();
  const [responsePayoffLetter, setResponsePayoffLetter] = useState<TaskResponse | any>();
  const [responseLender, setResponseLender] = useState<TaskResponse | any>();

  useEffect(() => {
    const _response1 = taskResponses?.find((item) => item.step === 1);
    setResponseStep1(_response1);

    const _response = taskResponses?.find((item) => item.key === 'payoff-letter');
    setResponsePayoffLetter(_response);

    const _responseLender = taskResponses?.find((item) => item.key === 'payoff-lender');
    setResponseLender(_responseLender);
  }, [taskResponses]);

  const taskHasResponses = taskResponses && taskResponses.length > 0;

  return (
    <section className='insurance-step-2 '>
      <div className="section-1">
        <h3 className="h3">
          {responseStep1?.key === 'yes' ? 'Upload your payoff letter' : 'Who is your current lender?'}
        </h3>
        <div className="mt-10">
          <p className="h4 h4-w4">
            {responseStep1?.key === 'yes' ?
              'Remember, it needs to be good through the closing date' :
              'We’ll reach out and get a up-to-date payoff letter'
            }
          </p>
        </div>
        <CardBorrowerImpersonation hasResponses={taskHasResponses} />

        <SectionIssues task={task} />

        <div className="mt-40" style={{ position: 'relative' }}>
          {responseStep1?.key === 'yes' ?
            <CardUploadResponse
              title="Payoff letter"
              isButtonSample={{ show: true, link: '' }}
              files={responsePayoffLetter?.files}
              state={responsePayoffLetter?.state}
              limitFiles={1}
              submit={{
                title: 'Submit for review',
                disabled: true,
                loading: false,
                modalConfirm: true,
                confirmDescription:
                  "After submitting, you'll have to contact us to make any changes.",
                onClick: () => {}
              }}
              insertHtml={
                <ActionAcceptAndReject
                  taskResponseId={responseStep1?.key === 'yes' ? responsePayoffLetter?._id : responseLender?._id}
                  task={{ id: task._id, key: task.key, name: task.name }}
                  files={responseStep1?.key === 'yes' ? responsePayoffLetter?.files : responseLender?.files}
                  currentState={responseStep1?.key === 'yes' ? responsePayoffLetter?.state : responseLender?.state}
                />
              }
            />
            :
            <CardLender />
          }

        </div>
      </div>

      <AddAnotherDoc task={task} />

      <ModalFinishTask
        visible={modalFinishTask}
        setVisible={setModalFinishTask}
        closeTask={closeTask}
      />
    </section>
  );
};
export default Step2;
